// React
import React, { Fragment } from 'react';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Helpers
import Helpers from '@Apis/helpers';

// Common components
import HideComponent from '@Components/Common/RestrictedAccess/HideComponent';
import ViewDocumentFooterDetails from '@Components/Common/ViewDocFooterLeftSection';

// File specific components
import { handleFileChangeHelper, renderChargesHelper, renderFreightHelper, splitChargesData, } from '../helper';

function ViewInvoiceFooter({
  props, state, updateState,
}) {

  const {
    user, selectedInvoice, priceMasking, getAttachmentByIdLoading, updateAttachmentLoading, MONEY
  } = props;

  const {
    fileList
  } = state;

  const handleFileChange = (fileListData) => (
    handleFileChangeHelper({ fileListData, props, state, updateState, })
  );

  const renderFreight = (position) => (
    renderFreightHelper({ position, props, state, updateState })
  );

  const renderCharges = (charge) => (
    renderChargesHelper({ charge, props, state, updateState })
  );

  const { isDataMaskingPolicyEnable, isHideSellingPrice } = priceMasking;

  return (
    <div className="view-document__totals-wrapper">
      <ViewDocumentFooterDetails
        fileList={fileList}
        disableAttachment={getAttachmentByIdLoading || updateAttachmentLoading}
        onFileChange={(value) =>
          handleFileChange(value)
        }
        canUpdateAttachment={Helpers.getPermission(
          Helpers.permissionEntities.INVOICE,
          Helpers.permissionTypes.UPDATE,
          user
        )}
        termsAndConditions={selectedInvoice?.terms_and_conditions}
        narration={selectedInvoice?.narration}
      />
      {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideComponent style={{
        width: 'fit-content'
      }} /> : <div className="view-document__totals">
        <div className="view-document__totals-field">
          <H3Text text="Sub Total" className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedInvoice?.invoice_base_price), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
        <div className="view-document__totals-field">
          <H3Text text="Discount" className="view-document__totals-field-name" />
          {selectedInvoice?.invoice_discount > 0
            ? <H3Text text={`(-) ${MONEY((selectedInvoice?.invoice_discount), selectedInvoice?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
            : <H3Text text={MONEY((selectedInvoice?.invoice_discount), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />}
        </div>
        {renderFreight('top')}
        {renderCharges(splitChargesData(selectedInvoice?.other_charges).chargeWithTaxName)}
        <div className="view-document__totals-field">
          <H3Text text="Taxable Amount" className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedInvoice?.taxable_amount || 0), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>

        {selectedInvoice?.tax_info?.map((tax, i) => (
          <div className="view-document__totals-field" key={i}>
            <H3Text text={tax?.tax_type_name} className="view-document__totals-field-name" />
            <H3Text text={MONEY((tax?.tax_amount), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
          </div>
        ))}

        {(selectedInvoice?.tcs_id || selectedInvoice?.tds_id) && (
          <div className="view-document__totals-field">
            <H3Text text={selectedInvoice?.tcs_id ? 'TCS' : 'TDS'} className="view-document__totals-field-name" />
            <H3Text text={selectedInvoice?.tcs_id ? `${MONEY((selectedInvoice?.tcs_info?.tcs_amount || 0), selectedInvoice?.org_currency_info?.currency_code)}` : `(-)${MONEY((selectedInvoice?.tds_info?.tds_amount || 0), selectedInvoice?.org_currency_info?.currency_code)}`} className={selectedInvoice?.tcs_id ? 'view-document__totals-field-value' : 'view-document__totals-field-value danger-text'} />
          </div>
        )}
        {renderFreight('bottom')}
        {renderCharges(splitChargesData(selectedInvoice?.other_charges).chargeWithoutTaxName)}
        <div className="view-document__totals-field">
          <H3Text text="Payable Amount" className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedInvoice?.invoice_grand_total), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
        {selectedInvoice?.credits_applied ? (
          <div className="view-document__totals-field">
            <H3Text text="Credit Applied" className="view-document__totals-field-name" />
            <H3Text text={`(-)${MONEY((selectedInvoice?.credits_applied || '0'), selectedInvoice?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
          </div>
        ) : <Fragment />}
        <div className="view-document__totals-field">
          <H3Text text="Round Off" className="view-document__totals-field-name" />
          {selectedInvoice?.invoice_round_off < 0
            ? <H3Text text={`(-)${MONEY((Math.abs(selectedInvoice?.invoice_round_off)), selectedInvoice?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
            : <H3Text text={MONEY((Math.abs(selectedInvoice?.invoice_round_off)), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value " />}

        </div>
        {selectedInvoice?.total_payment_made ? (
          <div className="view-document__totals-field">
            <H3Text text="Payment Made" className="view-document__totals-field-name" />
            <H3Text text={`(-) ${MONEY((selectedInvoice?.total_payment_made), selectedInvoice?.org_currency_info?.currency_code)}`} className="view-document__totals-field-value danger-text" />
          </div>
        ) : <Fragment />}

        <div className="view-document__totals-field view-document__totals-field-total">
          <H3Text text="Grand Total" className="view-document__totals-field-name" />
          <H3Text text={MONEY((selectedInvoice?.invoice_grand_total + selectedInvoice?.invoice_round_off - selectedInvoice?.credits_applied - selectedInvoice?.total_payment_made), selectedInvoice?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      </div>}
    </div>
  );
};

export default ViewInvoiceFooter;